import * as R from 'ramda'
import { RSAA } from 'redux-api-middleware'
import { getApiPath } from 'sidecar-utility-library'

import { initialState, types } from './types'

export const fetchBenefitCard = memberUuid => {
  return {
    [RSAA]: {
      endpoint: getApiPath('exp', `members/${memberUuid}/cards`), // TODO_EMILY: why is this plural if we're only fetching 1 card
      method: 'GET',
      types: [
        types.FETCH_MEMBER_BENEFIT_CARDS_REQUEST,
        types.FETCH_MEMBER_BENEFIT_CARDS_SUCCESS,
        types.FETCH_MEMBER_BENEFIT_CARDS_ERROR,
      ],
    },
  }
}

export const requestCardActivationData = memUuid => ({
  [RSAA]: {
    endpoint: getApiPath(`exp`, `cards/onetime-token?memberUuid=${memUuid}`),
    method: 'GET',
    types: [
      types.CARD_ACTIVATION_DATA_REQUEST,
      types.CARD_ACTIVATION_DATA_SUCCESS,
      types.CARD_ACTIVATION_DATA_ERROR,
    ],
  },
})

export const clearMemberPaymentCards = () => ({
  type: types.CLEAR_PAYMENT_CARDS,
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.FETCH_MEMBER_BENEFIT_CARDS_REQUEST: {
      return {
        ...state,
        benefitCards: {
          ...state.benefitCards,
          busy: true,
          error: '',
        },
      }
    }
    case types.FETCH_MEMBER_BENEFIT_CARDS_SUCCESS: {
      return {
        ...state,
        benefitCards: {
          ...state.benefitCards,
          busy: false,
          entity: {
            ...state.benefitCards.entity,
            [payload.memberUuid]: payload,
          },
        },
      }
    }
    case types.FETCH_MEMBER_BENEFIT_CARDS_ERROR: {
      return {
        ...state,
        benefitCards: {
          ...state.benefitCards,
          busy: false,
          error: R.pathOr(
            'Something went wrong',
            ['response', 'message'],
            payload,
          ),
        },
      }
    }

    // ----------

    case types.CARD_ACTIVATION_DATA_REQUEST: {
      return {
        ...state,
        cardActivation: {
          ...state.cardActivation,
          busy: true,
        },
      }
    }
    case types.CARD_ACTIVATION_DATA_SUCCESS: {
      return {
        ...state,
        cardActivation: {
          ...state.cardActivation,
          busy: false,
          marquetaApplicationId: payload.applicationId,
          tokens: {
            token: payload.token,
            cardToken: payload.cardToken,
            userToken: payload.userToken,
          },
          status: {
            state: payload.state,
            pinIsSet: payload.pinIsSet,
          },
        },
      }
    }
    case types.CARD_ACTIVATION_DATA_ERROR: {
      return {
        ...state,
        cardActivation: {
          ...state.cardActivation,
          busy: false,
          error: payload.response.message,
        },
      }
    }

    case types.CLEAR_PAYMENT_CARDS: {
      return {
        ...state,
        cards: initialState.cards,
      }
    }

    default:
      return state
  }
}
